import { Types, types } from '../types'

const initialState = {
  Waiting: false,
  LoginWaiting: false,
  Success: false,
  userEmail: '',
  Error: '',
  user: {},
  displayToast: false,
  isSetPassword: false,
  IsUserHasPassword: false,
  IsSendVerificationCode: false,
  loginPostEmailSuccess: false,
  registerPostEmailSuccess: false,
  sendVeridictionCodeSuccess: false,
  sendRegisterVerifictionCodeSuccess: false,
  Token: '',
  companies: {},

  forgotPasswordWaiting: false,
  forgotPasswordSuccess: false,
  forgotPasswordError: false,
  forgotPasswordStatus: {},


  getSessionIdWaiting: false,
  getSessionIdSuccess: false,
  getSessionIdError: false,
  getSessionId: {},
  signedInUser: null

}

const userReducer = (state = initialState, { type, action, error, params }) => {
  switch (type) {
    case types.LOGIN_REQUEST: {
      return {
        ...state,
        LoginWaiting: true,
        loginPostEmailSuccess: false,
        loginError: ''


      }
    }
    case types.LOGIN_REQUEST_SUCCESS: {
      return {
        ...state,
        LoginWaiting: false,
        loginPostEmailSuccess: true,
        IsUserHasPassword: action.data.userHasPassword,
        IsSendVerificationCode: action.data.sendVerificationCode,
      }
    }
    case types.LOGIN_REQUEST_ERROR: {

      return {
        ...state,
        LoginWaiting: false,
        loginError: action?.response?.data?.title
      }
    }

    case types.SEND_PASSWORD_REQUEST: {
      return {
        ...state,
        Waiting: false,
        Success: false,
        Error: '',
      }
    }
    case types.SEND_PASSWORD_SUCCESS: {

      return {
        ...state,
        Waiting: false,
        Success: true,
        UserHasPassword: action.response.data.userHasPassword,
        SendVerificationCode: action.response.data.sendVerificationCode
      }
    }
    case types.SEND_PASSWORD_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: action.data.message,
      }
    }


    case types.SEND_VERIFICTION_REQUEST: {
      return {
        ...state,
        Waiting: false,
        sendVeridictionCodeSuccess: false,
        Error: '',
      }
    }
    case types.SEND_VERIFICTION_SUCCESS: {
      return {
        ...state,
        Waiting: false,
        sendVeridictionCodeSuccess: true,
        user: action.data
      }
    }
    case types.SEND_VERIFICTION_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: "00000",
      }
    }


    case types.GET_ALL_COMPANY_REQUEST: {
      return {
        ...state,
        Waiting: true,
        Success: false,
        // companies:{}

      }
    }
    case types.GET_ALL_COMPANY_SUCCESS: {


      return {
        ...state,
        Waiting: false,
        Success: true,
        companies: action.data,

      }
    }
    case types.GET_ALL_COMPANY_ERROR: {


      return {
        ...state,
        Waiting: false,
        Error: error?.data?.title,
      }
    }



    case types.ADD_COMPANY_REQUEST: {
      return {
        ...state,
        addCompanyPending: true,
        addCompanySuccess: false,

      }
    }
    case types.ADD_COMPANY_SUCCESS: {


      return {
        ...state,
        addCompanyPending: false,
        addCompanySuccess: true,

      }
    }
    case types.ADD_COMPANY_ERROR: {


      return {
        ...state,
        addCompanyPending: false,
        addCompanyError: error?.data?.title,
      }
    }

    case types.REGISTER_REQUEST: {
      return {
        ...state,
        Waiting: true,
        registerPostEmailSuccess: false,
        registerError: '',
      }
    }
    case types.REGISTER_REQUEST_SUCCESS: {
      return {
        ...state,
        Waiting: false,
        registerPostEmailSuccess: true,

      }
    }
    case types.REGISTER_REQUEST_ERROR: {

      return {
        ...state,
        Waiting: false,
        registerError: error?.data?.title,
      }
    }


    case types.REGISTER_SEND_VERIFICTION_REQUEST: {
      return {
        ...state,
        Waiting: true,
        sendRegisterVerifictionCodeSuccess: false,
        Error: '',
      }
    }
    case types.REGISTER_SEND_VERIFICTION_SUCCESS: {

      return {
        ...state,
        Waiting: false,
        sendRegisterVerifictionCodeSuccess: true,
        user: action.data,
        Token: action.data.token
      }
    }
    case types.REGISTER_SEND_VERIFICTION_ERROR: {

      return {
        ...state,
        Waiting: false,
        Error: "00000",
      }
    }

    case types.LOGIN_PASSWORD_REQUEST: {
      return {
        ...state,
        Waiting: true,
        Success: false,
        Error: '',
      }
    }
    case types.LOGIN_PASSWORD_REQUEST_SUCCESS: {

      return {
        ...state,
        Waiting: false,
        Success: true,
        user: action.data
      }
    }
    case types.LOGIN_PASSWORD_REQUEST_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: "00000",
      }
    }


    case types.FORGOT_PASSWORD_REQUEST: {
      return {
        ...state,
        forgotPasswordWaiting: true,
        forgotPasswordSuccess: false,
        forgotPasswordError: false,
        forgotPasswordStatus: {}
      }
    }
    case types.FORGOT_PASSWORD_SUCCESS: {
      return {
        ...state,
        forgotPasswordWaiting: false,
        forgotPasswordSuccess: true,
        forgotPasswordError: false,
        forgotPasswordStatus: action.data
      }
    }
    case types.FORGOT_PASSWORD_ERROR: {
      return {
        ...state,
        forgotPasswordWaiting: false,
        forgotPasswordSuccess: false,
        forgotPasswordError: error.response,
        forgotPasswordStatus: {}
      }
    }




    case types.GET_SESSION_ID_REQUEST: {
      return {
        ...state,
        getSessionIdWaiting: true,
        getSessionIdSuccess: false,
        getSessionIdError: false,
        getSessionId: {}
      }
    }
    case types.GET_SESSION_ID_SUCCESS: {

      return {
        ...state,
        getSessionIdWaiting: false,
        getSessionIdSuccess: true,
        getSessionIdError: false,
        getSessionId: action.data
      }
    }
    case types.GET_SESSION_ID_ERROR: {
      return {
        ...state,
        getSessionIdWaiting: false,
        getSessionIdSuccess: false,
        getSessionIdError: error.response,
        getSessionId: {}
      }
    }


    case Types.SET_USER_INFO: {
      return {
        ...state,
        signedInUser: { ...params }
      }
    }


    case types.USER_RESET_PROPS: {
      return {
        ...state,

        forgotPasswordWaiting: false,
        forgotPasswordSuccess: false,
        forgotPasswordError: false,
        forgotPasswordStatus: {},

        Waiting: false,
        Success: false,
        Error: '',
        registerError: '',
        loginError: '',
        loginPostEmailSuccess: false,
        registerPostEmailSuccess: false,
        sendVeridictionCodeSuccess: false,
        sendRegisterVerifictionCodeSuccess: false,
        addCompanyPending: false,
        addCompanySuccess: false,
        user: localStorage.getItem("sipOnlineUser") ? state.user : {}

      }
    }

    default:
      return state
  }
}

export default userReducer
